/**
 * Created by keni on 24/07/2017.
 */
import $ from 'jquery';
export function readThemeColor(setColor, addAlpha) {
	let color = $('#site-theme-color-' + setColor).css('backgroundColor'),
		rgb;

	if (addAlpha) {
		rgb = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',');
		let r = rgb[0], g = rgb[1], b = rgb[2];

		rgb = `rgba(${r},${g},${b},${addAlpha})`;
	}
	else {
		rgb = color;
	}
	return rgb;
}



// WEBPACK FOOTER //
// ./resources/assets/js/theme.js